import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Hairline } from 'secondstep-components'

export const StyledHairline = styled(Hairline)`
  height: 2px;
  margin: 0.25rem 0 0.9375rem;
  background: ${themeGet('colors.paleGray')};
`
